<template>
  <div class="alert bg-light-info mt-3">
    <div>
      <FontAwesomeIcon icon="fa-light fa-circle-info" />
      {{ $t("password_validation.title") }}
    </div>
    <ul class="mb-0 mt-1">
      <li>{{ $t("password_validation.condition1") }}</li>
      <li>{{ $t("password_validation.condition2") }}</li>
      <li>{{ $t("password_validation.condition3") }}</li>
      <li>{{ $t("password_validation.condition4") }}</li>
      <li>{{ $t("password_validation.condition5") }}</li>
    </ul>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "PasswordInfoComponent",
  components: { FontAwesomeIcon },
  props: {},
};
</script>

<style lang="scss" scoped></style>
